import { FC } from 'react';
import { Modal } from '@hopskipdrive/react-components';
import { Button } from '@rideiq/shared/components/Button';

import { getCalendarConflictOptions, getHopSkipDriveClosedOptions } from './RideConflictModal.helpers';

export interface RideConflictModalProps {
  isOpen: boolean;
  message: string;
  canResubmit?: boolean;
  handleClose: () => void;
  handleResubmit: () => void;
}

export const RideConflictModal: FC<RideConflictModalProps> = ({
  isOpen,
  message,
  canResubmit,
  handleClose,
  handleResubmit,
}) => {
  const modalOptions = canResubmit ? getCalendarConflictOptions(message) : getHopSkipDriveClosedOptions(message);

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Modal.Title>{modalOptions.title}</Modal.Title>
      <Modal.Content>{modalOptions.content}</Modal.Content>
      <Modal.Actions>
        {canResubmit ? (
          <>
            <Button color="tertiary" onClick={handleClose}>
              Nevermind, go back
            </Button>
            <Button color="primary" variant="contained" onClick={handleResubmit}>
              Yes, schedule on day off
            </Button>
          </>
        ) : (
          <Button autoFocus color="primary" variant="contained" onClick={handleClose}>
            OK
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
};
